import { ApplicationType } from '../enums/application-type.enum';
import { IConfigOnboarding } from './config-onboarding';
import { AdditionalProperties } from './additional-properties';

export interface IProcessorConfig {
  contractID: string;
  applicationType: ApplicationType;
  nlsa: string;
  bankCode: string;
  architectureType: string;
  tasa: string;

  additionalCardAcceptorReferenceData: string;
  additionalReference?: string;
  cardAcceptorReferenceData: string;
  reference?: string;
  parameterDownloadCommunicationDetails: string;
  tlp?: string;
  usualConnectionMode: string;
  connectionMode?: string;
  formattedConnectionMode?: string;
  ipPort?: string;

  ert: string;
  formattedErt?: string;
  itp: string;
  verificationCapabilities?: any; // is hardcoded in the CB PIM
  deviceType: string;
  formattedSettlementType?: string;
  defaults?: {};
  brandconfigMerchant?: {};
  onboarding?: IConfigOnboarding;

  //Rts
  groupID?: string;
  terminalID?: string;
  tppID?: string;

  //WorldPay
  companyId?: string;

  // Klarna
  processorId: string;
  merchantId: string;

  // TelecheckUS
  additionalProperties?: AdditionalProperties;
}
